import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import translation_it from 'locales/it/translation.json'
import translation_en from 'locales/en/translation.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'it-IT': {
        translation: translation_it,
      },
      'en-US': {
        translation: translation_en,
      },
    },
    fallbackLng: 'it-IT',
    debug: process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  })

export default i18n
